export const kardex = {
	title: "Ficha Kardex",
	label: "Inventario",
	storage: "Inventario",
	product: "Producto",
	seeProduct: "Ver producto",
	period: "Período",
	applyFilters: "Aplicar filtros",
	at: "hasta",
	destiny: "Destino",
	origin: "Origen",
	dateFilterBy: {
		label: "Filtrar período por",
		options: {
			events: "Eventos entre el período",
			interval: "Todos entre el período",
		},
	},
	transferTypeTranslate: {
		input: "Entrada",
		transferOut: "Transferencia (salida)",
		transferIn: "Transferencia (entrada)",
		lost: "Pérdida",
		sell: "Venta",
		refund: "Pérdida por reembolso",
		manual: "Ajuste Manual",
		productionIn: "Entrada de producción",
		productionOut: "Salida de producción",
		productionOutTo: "Salida de producción para",
		invoice: "Entrada factura fiscal",
		inventory: "Inventario",
		productionLost: "Pérdida de producción",
		cardExchange: "Cambio por tarjeta",
	},
	header: {
		date: "Fecha",
		employeeName: "Empleado",
		obs: "Observación",
		initial: "Saldo inicial",
		noValue: "Valor no informado",
		type: "Transacción",
		count: "Cantidad",
		final: "Saldo final",
		unitCostValue: "Costo unit.",
		selectStock: "Seleccione el inventario",
		selectProduct: "Seleccione el producto",
		applyFilters: "Aplicar filtros",
		description:
			"La ficha kardex es una representación del inventario y movimientos de un elemento. Es similar a la pantalla de movimientos, presentando el historial de entradas y salidas, la cantidad movida, el saldo y valores en cada movimiento.",
	},
	nameNotFound: "Nombre no encontrado",
	download: "Exportar a Excel",
	emptyState: {
		title: "Seleccione inventario para comenzar",
		description:
			"Seleccione el inventario, producto y el período para visualizar la Ficha Kardex del producto",
	},
};
